export default __webpack_public_path__ + "static/126-320bf667e58340e4065d49c63e614df3.jpg";